import React, { useState } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

const FullDayAbsenceForm = ({ onClose, onAbsenceRegistered, profesorId }) => {
    const [fechaDiaCompleto, setFechaDiaCompleto] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [observacionesDiaCompleto, setObservacionesDiaCompleto] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post('/api/ausencias/registrar/dia-completo', {
                profesorId: profesorId,
                fecha: fechaDiaCompleto,
                observaciones: observacionesDiaCompleto
            });

            if (response.status === 200) {
                onAbsenceRegistered(); // Callback para recargar datos en el calendario
                onClose(); // Cerrar el modal
            } else {
                setError('Error al registrar la ausencia de día completo');
            }
        } catch (error) {
            setError('Error de conexión con el servidor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ marginTop: '5rem' }} className="modal fade" id="modalAusenciaDiaCompleto" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-danger text-white">
                        <h5 className="modal-title">Registrar Ausencia Día Completo</h5>
                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="fechaDiaCompleto" className="form-label">Fecha:</label>
                                <input type="date" id="fechaDiaCompleto" className="form-control" value={fechaDiaCompleto} onChange={(e) => setFechaDiaCompleto(e.target.value)} required />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="observacionesDiaCompleto" className="form-label">Observaciones:</label>
                                <textarea id="observacionesDiaCompleto" className="form-control" rows="3" value={observacionesDiaCompleto} onChange={(e) => setObservacionesDiaCompleto(e.target.value)}></textarea>
                            </div>
                            {error && <div className="alert alert-danger">{error}</div>}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={onClose}>Cancelar</button>
                                <button type="submit" className="btn btn-danger" disabled={loading}>
                                    {loading ? 'Registrando...' : <><i className="bi bi-save"></i> Registrar ausencia día completo</>}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FullDayAbsenceForm;